"use strict";

exports.__esModule = true;
exports["default"] = exports.InputBase = exports.IconBox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["autofocus", "bg", "borderRadius", "boxShadow", "className", "icon", "onChange", "placeholder", "value", "color", "fontSize", "fontWeight", "px", "py", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "text-input__IconBox",
  componentId: "sc-1xpblfj-0"
})(["height:16px;"]);
exports.IconBox = IconBox;
var InputBase = (0, _styledComponents["default"])(_primitives["default"].Input).withConfig({
  displayName: "text-input__InputBase",
  componentId: "sc-1xpblfj-1"
})(["background:transparent;border:none;font-family:inherit;outline:none;&::-ms-clear{display:none;}&::placeholder{color:", ";}"], function (props) {
  return (0, _styles.colors)("gray-menu", props);
});
exports.InputBase = InputBase;
var propTypes = {
  /** Input element autoFocus attribute */
  autofocus: _propTypes.bool,

  /** Background color styling prop */
  bg: _propTypes.string,

  /** Border radius styling prop */
  borderRadius: _utils.stylePropType,

  /** Box shadow styling prop */
  boxShadow: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number, (0, _propTypes.arrayOf)(_propTypes.string), _propTypes.string]),

  /** Classname for styled-components */
  className: _propTypes.string,

  /** Color styling prop, also sets fill property for icon color */
  color: _utils.stylePropType,

  /** Font size styling prop */
  fontSize: _utils.stylePropType,

  /** Font weight style prop */
  fontWeight: _utils.stylePropType,

  /** Icon ID string */
  icon: _propTypes.string,

  /** onChange event handler */
  onChange: _propTypes.func,

  /** Placeholder text to show while input is empty */
  placeholder: _propTypes.string,

  /** Padding x-axis styling prop */
  px: _utils.stylePropType,

  /** Padding y-axis styling prop */
  py: _utils.stylePropType,

  /** Input html tag type */
  type: _propTypes.string,

  /** Current input text value, undefined if empty */
  value: _propTypes.string
};
var defaultProps = {
  bg: "white",
  borderRadius: "3px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.1)",
  color: "coolgray",
  fontSize: 2,
  fontWeight: 1,
  px: 2,
  py: 1,
  type: "text"
};
/**
 * Text input is the themed version on <input type="text" />. It accepts an
 * icon component as a prop that displays at the beginning of the input and
 * focuses it on click. The root is a <Flex /> primitive and it accepts all of
 * the corresponding style related props. The input container handles color,
 * font-size, and font-weight props.
 */

var TextInput = function TextInput(_ref) {
  var autofocus = _ref.autofocus,
      bg = _ref.bg,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      className = _ref.className,
      Icon = _ref.icon,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      value = _ref.value,
      color = _ref.color,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      px = _ref.px,
      py = _ref.py,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var textInput = (0, _react.useRef)(null);

  var handleFocus = function handleFocus() {
    textInput.current.focus();
  };

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    alignItems: "center",
    backgroundColor: bg,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    className: className,
    fill: color,
    onClick: handleFocus,
    px: px,
    py: py
  }, props), Icon ? /*#__PURE__*/_react["default"].createElement(IconBox, {
    mr: 1,
    onClick: handleFocus
  }, /*#__PURE__*/_react["default"].createElement(Icon, null)) : null, /*#__PURE__*/_react["default"].createElement(InputBase, {
    autofocus: autofocus,
    color: color,
    fontSize: fontSize,
    fontWeight: fontWeight,
    onChange: onChange,
    placeholder: placeholder,
    ref: textInput,
    type: type,
    value: value,
    width: 1
  }));
};

TextInput.defaultProps = defaultProps;
TextInput.propTypes = propTypes;
var _default = TextInput;
exports["default"] = _default;